import React from "react";

const SaveButtons = ({ onCancel, onSave, taxId }) => {
    return (
        <div className="w-full flex justify-end items-center gap-3 mt-10">
            <button
                type="button"
                className="w-[135px] h-12 flex justify-center items-center gap-[8px] font-inter bg-white group 
                border border-ec-primary px-4 rounded-lg text-ec-primary hover:text-white 
                hover:bg-ec-primary focus:shadow-none focus:text-white focus:bg-ec-secondary 
                lg:text-sm md:text-xs sm:text-sm transition-all ease-in-out duration-500 leading-[26px]"
                onClick={onCancel}
            >
                Cancel
            </button>
            <button
                type="button"
                className="w-[135px] h-12 flex justify-center items-center rounded-lg border font-medium text-base 
                border-ec-primary bg-ec-primary text-white"
                onClick={onSave}
            >
                {taxId ? "Update" : "Create"}
            </button>
        </div>
    );
};

export default SaveButtons;
